import React, { ReactElement } from 'react';
import { useLocation, useParams } from 'react-router';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import Layout from '../../Layout';
import isPredbeznaInformacia from '../../../function/isPredbeznaInformacia';
import routes from '../../../routing/routes';
import GlobalErrors from '../../../module/GlobalErrors';
import SecuredPage from '../../../module/SecuredPage';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import { VseobecnyObalMaterialu } from '../../../module/SprievodnyDokument/CreateFromForm';
import useVseobecnyObalMaterialuFormData from './hook/useVseobecnyObalMaterialuFormData';
import {
  editObalMaterialuVseobecnyClient,
} from '../../../client/external/evidencnaaplikacia/obalMaterialuVseobecnyClient';
import { ObalMaterialu } from '../../../model/sprievodnyDokument/obalMaterialu/ObalMaterialuFormData';
import { useClient } from '../../../context/ClientStatusContext';

const VseobecnyObalMaterialuEditPage = (): ReactElement => {
  const location = useLocation();
  const {
    type,
    year: yearParam,
    index: indexParam,
    sprievodnyDokumentUuid,
    stadiumUuid,
  } = useParams();
  const year = parseInt(yearParam, 10);
  const index = parseInt(indexParam, 10);

  const {
    formDataResponse,
    formDataStatus,
  } = useVseobecnyObalMaterialuFormData(
    type,
    year,
    index,
    sprievodnyDokumentUuid,
  );

  const {
    wrapClient: editObalMaterialuVseobecny,
    status: submitStatus,
  } = useClient(editObalMaterialuVseobecnyClient);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: isPredbeznaInformacia(type) ? 'Predbežné informácie' : 'Legislatívne procesy',
          to: isPredbeznaInformacia(type) ? routes.procesy.predbeznaInformacia.list : routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          heading: 'Sprievodná dokumentácia',
          to: routes.procesy.detail.sprievodneDokumenty.edit.withParams(type, year, index),
        },
        {
          heading: 'Obal materiálu',
          to: location.pathname,
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={formDataStatus.loading}>
        {formDataStatus.finished && (
          <SecuredPage
            hasOpravneniePracovneKroky={formDataResponse?.materialDetail?.hasOpravnenieSprievodneDokumenty}
            requestStatus={formDataStatus?.responseCode}
          >
            <>
              {formDataResponse?.materialDetail && formDataResponse?.formData && (
                <>
                  <PageHeadingWithBackButton
                    headingCaption={'Legislatívny proces '
                      + `${formDataResponse.materialDetail.cisloLegislativnehoMaterialu}`}
                    heading="Obal materiálu"
                    withBackLink
                  />
                  <Loader loading={formDataStatus.loading}>
                    <VseobecnyObalMaterialu
                      initFormData={formDataResponse.formData}
                      onSubmitForm={(formData: ObalMaterialu) => editObalMaterialuVseobecny(
                        formDataResponse.materialDetail.uuid,
                        formData,
                        sprievodnyDokumentUuid,
                        stadiumUuid,
                      )}
                      submitStatus={submitStatus}
                    />
                  </Loader>
                </>
              )}
            </>
          </SecuredPage>
        )}
      </Loader>
    </Layout>
  );
};

export default VseobecnyObalMaterialuEditPage;
